import { Phone, MessageCircle, MapPin } from "lucide-react";
import { BUSINESS, NAV_LINKS, LOCATIONS } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { openGate } = useContact();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B1733] text-white pt-14 pb-8"
    >
      <div className="msc-container grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-lg bg-[#F59E0B] text-[#1F2937] flex items-center justify-center font-display font-black">
              MS
            </div>
            <div>
              <div className="font-display font-black text-lg">{BUSINESS.name}</div>
              <div className="text-xs text-[#FBBF24] font-semibold uppercase tracking-wider">
                Since 1971
              </div>
            </div>
          </div>
          <p className="mt-4 text-sm text-white/75 leading-relaxed">
            Bhiwandi ka 54+ saal purana cleaning store. Handmade soaps, retail
            aur wholesale — sab kuch ek chhat ke neeche.
          </p>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-[#FBBF24]">
            Pages
          </h4>
          <ul className="mt-4 space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-white/80 hover:text-white transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Locations */}
        <div className="sm:col-span-2 lg:col-span-1">
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-[#FBBF24]">
            3 Locations
          </h4>
          <ul className="mt-4 space-y-3">
            {LOCATIONS.map((loc) => (
              <li key={loc.title} className="flex gap-2 text-sm text-white/80">
                <MapPin className="w-4 h-4 text-[#FBBF24] shrink-0 mt-0.5" />
                <div>
                  <div className="font-semibold text-white">{loc.title}</div>
                  <div className="text-xs text-white/60 leading-snug">
                    {loc.address}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact & Resources */}
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-wider text-[#FBBF24]">
            Help & Resources
          </h4>
          <div className="mt-4 flex flex-col gap-3">
            <button
              onClick={() => openGate()}
              data-testid="footer-contact-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#F59E0B] hover:bg-[#D97706] text-[#1F2937] rounded-md px-4 py-2.5 text-sm font-bold transition-all"
            >
              <MessageCircle className="w-4 h-4" /> Message Us
            </button>
            <a
              href="#faq"
              data-testid="footer-faq-btn"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white rounded-md px-4 py-2.5 text-sm font-semibold transition-all"
            >
              Read FAQs
            </a>
          </div>
        </div>
      </div>

      <div className="msc-container mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/60">
        <div>
          © {year} {BUSINESS.name}. All Rights Reserved · Founded by Janab {BUSINESS.founder} Saheb.
        </div>
        <div>Built with care · Bhiwandi, Maharashtra 🇮🇳</div>
      </div>
    </footer>
  );
};
